<template>
    <div class="loadingscreen">
        <div class="loadingscreen--inner">
            <div class="logo">
                <img :src="'/vue-apps/zvshk-portal/assets/img/logoSmall.png'" alt="">
                <!-- <span class="logo-blue"></span>
                <span class="logo-red"></span>
                <span class="logo-yellow"></span>
                <span class="logo-white"></span>
                <span class="text">sanitär<br>heizung<br>klima</span> -->
            </div>
            <div class="bar">
                <ProgressBar :value="progress" style="height: 12px" :showValue="false"></ProgressBar>
            </div>
            <div class="text">
                <span>Formular wird geladen</span>
            </div>
        </div>
    </div>
</template>

<script setup>
defineProps({progress:Object})
</script>